import { nil, NO, UIColor, UITextView, UIView, YES } from "uicore-ts"
import { RHFocusManager } from "../../Custom components/RH/Keyboard navigation/RHFocusManager"
import { RHPageFocusManager } from "../../Custom components/RH/Keyboard navigation/RHPageFocusManager"
import { RHButton } from "../../Custom components/RH/RHButton"
import { RHDropdown } from "../../Custom components/RH/RHDropdown"
import {
    RHButtons,
    RHColors,
    RHFont,
    RHSpacing
} from "../../Custom components/RH/Utils_slop/RHDesignTokens"
import {
    RHCompanyMembershipRequestRole,
    RHCompanyMembershipWorkflow
} from "../../SocketClientFunctions"
import { RHCompanyMemberPresentation } from "./CompanyMemberPresentation"


export class JoinRequestDialogView extends UIView {

    readonly titleLabel = new UITextView(nil, UITextView.type.paragraph)
        .configuredWithObject({
            textColor: RHColors.textHeading,
            style: {
                fontSize: RHFont.sizeLarge,
                fontWeight: RHFont.weightSemibold
            }
        })
        .addedAsSubviewToView(this)

    readonly emailLabel = new UITextView()
        .configuredWithObject({
            textColor: RHColors.textSecondary,
            isSingleLine: YES,
            style: { fontSize: RHFont.sizeSmall }
        })
        .addedAsSubviewToView(this)

    readonly roleDropdown = new RHDropdown<RHCompanyMembershipRequestRole>()
        .configuredWithObject({
            labelText: "Taotletud roll",
            options: [
                { label: "Peakasutaja", value: "administrator" },
                { label: "Hankija esindaja", value: "procurer" },
                { label: "Pakkuja esindaja", value: "offerer" }
            ]
        })
        .addedAsSubviewToView(this)

    readonly cancelButton = new RHButton()
        .configuredWithObject({
            titleLabel: { text: "Sulge", style: { fontSize: RHButtons.compactFontSize } },
            variant: "secondary",
            contentPadding: RHButtons.compactContentPadding
        })
        .addedAsSubviewToView(this)

    readonly rejectButton = new RHButton()
        .configuredWithObject({
            titleLabel: { text: "Lükka tagasi", style: { fontSize: RHButtons.compactFontSize } },
            variant: RHButtons.destructiveUtilityVariant,
            contentPadding: RHButtons.compactContentPadding
        })
        .addedAsSubviewToView(this)

    readonly approveButton = new RHButton()
        .configuredWithObject({
            titleLabel: { text: "Kinnita", style: { fontSize: RHButtons.compactFontSize } },
            variant: "success",
            contentPadding: RHButtons.compactContentPadding
        })
        .addedAsSubviewToView(this)

    override _focusManager = new RHFocusManager(() => [
        this.cancelButton,
        this.rejectButton,
        this.approveButton
        ])

    _requestedRole?: RHCompanyMembershipRequestRole


    constructor(elementID?: string) {
        super(elementID)
        this.backgroundColor = UIColor.whiteColor
        this.cancelButton.controlEventTargetAccumulator.PrimaryActionTriggered = () => {
            this.dialogView?.dismiss()
        }
    }


    override wasAddedToViewTree() {
        super.wasAddedToViewTree()
        RHPageFocusManager.shared.pushManagerAsNewLayer(this._focusManager!)
    }


    override wasRemovedFromViewTree() {
        super.wasRemovedFromViewTree()
        RHPageFocusManager.shared.popLayer()
    }


    configureForWorkflow(workflow: RHCompanyMembershipWorkflow) {
        const identityPresentation = RHCompanyMemberPresentation.identityPresentationForPerson({
            name: workflow.userName,
            email: workflow.userEmail
        })
        this.titleLabel.text = "Liitumistaotlus"
        if (identityPresentation.escapedDisplayName) {
            this.titleLabel.text += `: ${identityPresentation.escapedDisplayName}`
        }
        this.emailLabel.text = identityPresentation.escapedEmail
        this._requestedRole = workflow.requestedRole
        this.roleDropdown.selectedValue = workflow.requestedRole
        this.roleDropdown.enabled = NO
    }


    get approvedRole(): RHCompanyMembershipRequestRole | undefined {
        return this._requestedRole
    }


    override layoutSubviews() {
        super.layoutSubviews()
        const bounds = this.contentBoundsWithInset(this.core.paddingLength)

        bounds
            .rectangleWithHeight(this.titleLabel)
            .assignedAsFrameOfView(this.titleLabel)
            .rectangleForNextRow(RHSpacing.tiny, this.emailLabel)
            .assignedAsFrameOfView(this.emailLabel)
            .rectangleForNextRow(RHSpacing.large, this.roleDropdown)
            .assignedAsFrameOfView(this.roleDropdown)
            .rectangleForNextRow(RHSpacing.large, RHButtons.compactHeight)
            .distributeViewsEquallyAlongWidth(
                [this.cancelButton, this.rejectButton, this.approveButton],
                RHSpacing.medium
            )
    }


    override intrinsicContentWidth() {
        return 540
    }


    override intrinsicContentHeight() {
        return 250
    }

}
